// @flow
import * as React from 'react';

import Group from 'sail/Group';
import {BodyAlt} from 'sail/Text';
import {TextInput} from 'sail/Input';
import {InfoTooltip} from 'sail/Tooltip';

type SetNodeIdProps = {|
  id: string,
  setId: (string) => void,
|};
export const SetNodeId = ({id, setId}: SetNodeIdProps) => (
  <Group spacing={4}>
    <label htmlFor="nodeId">
      <BodyAlt>Id</BodyAlt>
    </label>
    <Group alignItems="center" direction="horizontal" spacing={12}>
      <TextInput id="nodeId" onChange={setId} value={id} />
      <InfoTooltip content="Each node needs a unique ID so we know where to connect the edges. We autogenerate an ID for you here using the node's text, but you can replace it." />
    </Group>
  </Group>
);
